import * as i0 from '@angular/core';
import { Inject, Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
const EZ_CRYPTO_PASSWORD = 'EZ_CRYPTO_PASSWORD';
let EzCryptoService = /*#__PURE__*/(() => {
  class EzCryptoService {
    constructor(password) {
      this.password = password;
      this.keySize = 8;
      this.ivSize = 16;
      this.iterations = 100;
    }
    encrypt(message) {
      const salt = CryptoJS.lib.WordArray.random(this.ivSize);
      const iv = CryptoJS.lib.WordArray.random(this.ivSize);
      const key = this.getPBKDF2Code(this.password, salt);
      const encrypted = CryptoJS.AES.encrypt(message, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
      });
      // salt, iv will be hex 32 in length
      // append them to the ciphertext for use  in decryption
      return salt.toString() + iv.toString() + encrypted.toString();
    }
    decrypt(transitMessage) {
      const salt = CryptoJS.enc.Hex.parse(this.getSaltFromMessage(transitMessage));
      const iv = CryptoJS.enc.Hex.parse(this.getIVFromMessage(transitMessage));
      const key = this.getPBKDF2Code(this.password, salt);
      const encrypted = transitMessage.substring(64);
      const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    }
    encHexParse(salt) {
      return CryptoJS.enc.Hex.parse(salt);
    }
    getPBKDF2Code(message, salt) {
      return CryptoJS.PBKDF2(message, salt, {
        keySize: this.keySize,
        iterations: this.iterations
      });
    }
    getSaltFromMessage(transitMessage) {
      return transitMessage.substr(0, 32);
    }
    getIVFromMessage(transitMessage) {
      return transitMessage.substr(32, 32);
    }
    getHashFromMessage(transitMessage) {
      return transitMessage.substring(32);
    }
    static {
      this.ɵfac = function EzCryptoService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EzCryptoService)(i0.ɵɵinject(EZ_CRYPTO_PASSWORD));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EzCryptoService,
        factory: EzCryptoService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EzCryptoService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { EZ_CRYPTO_PASSWORD, EzCryptoService };
